export default {"name":"Classic","dark":false};